class AddShapeUnit {
    constructor(shape, diagram) {
        this.shape = shape;
        this.diagram = diagram;
        this.title = 'New shape';
    }
    undo() {
        this.diagram.deselect();
        this.diagram.remove(this.shape, false);
    }
    redo() {
        this.diagram._addShape(this.shape, false);
    }
}

export { AddShapeUnit };
